export const ROW_IS_SELECTED = 'ROW_IS_SELECTED';

export function selectRow(row) {
    return {
        type: ROW_IS_SELECTED,
        payload: row
    }
}
